export default __webpack_public_path__ + "static/mastermatchmaker_screen_1-6ed031195d9494742003eb48b83b9aa9.svg";